<template>
    <div class="row action-buttons justify-content-between fixed-bottom">
        <div class="col-10">
            <b-button
                :disabled="!isSaveAllowed"
                @click="saveItem"
                class="mr-2"
                v-if="!hideSave"
                variant="primary"
            >
                <slot name="saveButtonText">{{ saveButtonLabel }}</slot>
            </b-button>
            <b-button
                :disabled="!isSaveAllowed"
                @click="saveItemAndClose"
                class="mr-2"
                v-if="!(hideClose || hideSave)"
                variant="primary"
            >
                <slot name="saveButtonAndCloseText">{{
                    saveAndCloseButtonLabel
                }}</slot>
            </b-button>

            <b-button
                :disabled="!isSaveAllowed"
                @click="saveAndNew"
                class="mr-2"
                v-if="!hideSave && showCreateAndNew"
                variant="primary"
            >
                <slot name="saveAndNewButtonText">{{
                    saveAndNewButtonLabel
                }}</slot>
            </b-button>

            <b-button
                @click="closeForm"
                class="mr-2"
                v-if="!hideClose"
                variant="primary"
            >
                <slot name="closeButtonText">Close</slot>
            </b-button>

            <slot name="left"></slot>
            <slot />
        </div>
        <div class="col-2">
            <slot name="right"></slot>
            <b-button @click="deleteItem" v-if="!hideDelete" variant="danger">
                <trash-can-icon />
                Delete
            </b-button>
        </div>
    </div>
</template>

<style scoped>
.o-loader {
    position: absolute;
    margin-top: 0;
    margin-bottom: 0;
}

.action-buttons {
    background-color: silver;
    padding: 7px;
    bottom: 18px;
    /*position: fixed;*/
    /*bottom: 0px;*/
    /*left: 0px;*/
    width: 100%;
    z-index: 4;
}
</style>

<script>
import _ from "lodash";
import TrashCanIcon from "vue-material-design-icons/TrashCan";

export default {
    name: "OActionButtons",
    props: {
        create: Boolean,
        showCreateAndNew: Boolean,
        item: Object,
        formState: Object,
        labelForCreate: { type: String, default: "Create" },
        labelForUpdate: { type: String, default: "Update" },
        deleteMessage: {
            type: String,
            default: "Are you sure you want to delete this item?",
        },
        deleteTitle: { type: String, default: "Deleting Item" },
        deleteConfirmText: { type: String, default: "Delete Item" },
        hideClose: { type: Boolean, default: false },
        hideSave: { type: Boolean, default: false },
        hideDelete: { type: Boolean, default: false },
        canSave: { type: Function, default: null },
    },
    components: { TrashCanIcon },
    methods: {
        saveItem() {
            this.$emit("save", this.item);
        },
        saveItemAndClose() {
            this.$emit("saveAndClose", this.item); // TODO Wait somehow and close when returns...
        },
        deleteItem() {
            var options = {
                title: this.deleteTitle,
                headerBgVariant: "danger",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "YES",
                cancelVariant: "success",
                cancelTitle: "Cancel",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
            };
            this.$bvModal
                .msgBoxConfirm(this.deleteMessage + "", options)
                .then((value) => {
                    if (value) {
                        this.$emit("delete", this.item);
                    }
                });
        },
        closeForm() {
            this.$router.go(-1);
        },
        saveAndNew() {
            this.$emit("saveAndNew", this.item);
        },
    },
    computed: {
        saveButtonLabel() {
            if (this.create) {
                return this.labelForCreate;
            } else {
                return this.labelForUpdate;
            }
        },
        saveAndCloseButtonLabel() {
            return this.saveButtonLabel + " And Close";
        },
        saveAndNewButtonLabel() {
            return this.saveButtonLabel + " And New";
        },
        isSaveAllowed() {
            if (this.canSave != null) {
                if (_.isFunction(this.canSave)) {
                    return this.canSave(this.item);
                }
            }

            return !this.formState.invalid && this.formState.dirty;
        },
        canCreateAndNew() {
            return this.showCreateAndNew || false;
        },
    },
    created() {},
    data: () => ({}),
};
</script>
